import axios from "axios";
import { API_BASE_URL1 } from "../Services/baseApiUrl";
import axiosInstance from "../../Hooks/axoisInstance";
//const countryId =localStorage.getItem("country_Id");

const getToken = () => {
    return localStorage.getItem("token");
  };

  export const AllCollectionPointsCategoryDetails = async () => {
    try {
      const response = await axiosInstance.get( API_BASE_URL1 +`collection_point_categoty/get`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`
        }
      }
      );
      return response.data;
    } catch (error) {
      throw error;
     
    }
  };

//   export const AddCollectionPointsDetails= async (collectionPointData) => {
//     try {
//       const response = await axios.post( API_BASE_URL +`collection_point/create`, collectionPointData ,
//       {
//         headers: {
//             Authorization: `Bearer ${getToken()}`
//         },
      
//       });
  
//       if (!response.ok) {
//         throw new Error("Failed to add Collection Points");
//       }
  
//       return response;
//     } catch (error) {
//       throw new Error("Error adding Collection Points: " + error.message);
//     }
//   };

//   export const UpdateCollectionPointsDetails= async (collectionPointData) => {
//     try {
//       const response = await axios.post( API_BASE_URL +`collection_point/update`, collectionPointData ,
//       {
//         headers: {
//             Authorization: `Bearer ${getToken()}`
//         },
      
//       });
  
//       if (!response.ok) {
//         throw new Error("Failed to Update Collection Points");
//       }
  
//       return response;
//     } catch (error) {
//       throw new Error("Error Update Collection Points: " + error.message);
//     }
//   };